import * as React from 'react'

import { reportFocusSearch } from '../../../../common/analytics/searchBarAnalytics'
import { ICategoryPageBlockComponent } from '../../../../typings/pageBlocks'
import SearchIcon from '../../../components/icons/search'
import SearchBarForm from '../../../components/searchBar/searchBarForm'
import SearchBarInput from '../../../components/searchBar/searchBarInput'

import * as styles from './searchBlock.module.css'

const SearchBlock = ({
  title,
  subtitle,
  locationParams,
  makeSearchLink
}: ICategoryPageBlockComponent) => {
  const gaTrackingLabel = 'Search bar - end of page'

  const onFocus = async (event: React.FormEvent<HTMLInputElement>) => {
    event.preventDefault()
    reportFocusSearch(gaTrackingLabel)
  }

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <header>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div className={styles.searchWrapper}>
          <SearchBarForm
            makeSearchLink={makeSearchLink}
            className="search-field -size-xl"
            gaTrackingLabel={gaTrackingLabel}
          >
            <div style={{ margin: 0, padding: 0, display: 'inline' }}>
              <input name="utf8" type="hidden" value="✓" />
            </div>

            <div className="search-field__input">
              <SearchBarInput
                value={locationParams.term}
                className="search-field__input-field"
                name="term"
                placeholder="Search within this category"
                onFocus={onFocus}
              />
            </div>

            <button className="fds-c-button search-field__button" type="submit">
              <SearchIcon />
            </button>
          </SearchBarForm>
        </div>
      </div>
      <div className={styles.wrapper}>
        {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
      </div>
    </section>
  )
}

export default SearchBlock
